import FAVICONS from 'shared/favicons';
import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';
import getEntryDetailPageChildren from './entry_detail_page/entryDetailPageChildren';

const DIARY_DETAIL_CHILDREN = [
    {
        path: '',
        component: () => import(/* webpackChunkName: "diary" */ './DiaryDetailBlog'),
        props: true,
        name: 'DiaryDetailBlog'
    },
    {
        path: 'settings',
        component: () => import(/* webpackChunkName: "diary" */ './diary_settings/DiaryDetailSettings'),
        props: true,
        name: 'DiaryDetailSettings'
    },
    {
        path: 'reports',
        component: () => import(/* webpackChunkName: "diary" */ './reports/DiaryDetailReports'),
        props: true,
        name: 'DiaryDetailReports'
    },
    {
        path: 'reports/:reportId/',
        component: () => import(/* webpackChunkName: "diary" */ './reports/DiaryDetailReport'),
        props: true,
        name: 'DiaryDetailReport'
    },
    {
        path: 'manage-access',
        component: () => import(/* webpackChunkName: "diary" */ './manage_access/DiaryDetailManageAccess'),
        props: true,
        name: 'DiaryDetailManageAccess'
    },
    {
        path: 'search',
        component: () => import(/* webpackChunkName: "diary" */ './search/DiaryDetailSearch'),
        props: true,
        name: 'DiaryDetailSearch'
    },
    {
        path: 'answer/:locationId(\\d+)/:answerId(\\d+)/comments',
        component: () => import(/* webpackChunkName: "diary" */ './DiaryLocationAnswerCommentsPage'),
        props: true,
        name: 'DiaryLocationAnswerCommentsPage'
    },
    {
        path: 'answer/:locationId(\\d+)/:answerId(\\d+)/form',
        component: () => import(/* webpackChunkName: "diary" */ './DiaryLocationAnswerFormPage.vue'),
        props: true,
        name: 'DiaryLocationAnswerFormPage'
    },
    {
        path: 'entry/:entryId(\\d+)/',
        component: () => import(/* webpackChunkName: "diary" */ './entry_detail_page/BlogEntryDetailPage'),
        children: getEntryDetailPageChildren('diaryEntryDetailPage-'),
        props: true,
    },
];

export default defineSection({
    resetScroll: true,
    head: sectionHead({icon: FAVICONS.diary}),
    routes: [
        {
            path: '/diaries/list/',
            component: () => import(/* webpackChunkName: "diary" */ './diaries_list/MyDiariesList'),
            props: true,
            name: 'DiariesListPage'
        },
        {
            path: '/diaries/templates/',
            component: () => import(/* webpackChunkName: "diary" */ './templates/DiaryTemplatesListPage'),
            props: true,
            name: 'DiaryTemplatesListPage'
        },
        {
            path: '/diaries/templates/:templateId(\\d+)/',
            component: () => import(/* webpackChunkName: "diary" */ './templates/DiaryTemplateDetailPage'),
            props: true,
            name: 'DiaryTemplateDetailPage'
        },
        {
            path: '/diaries/:diaryId(\\d+)/:accessCode([a-zA-Z0-9_@!$\-]{14,100})?/',
            component: () => import(/* webpackChunkName: "diary" */ './DiaryDetail'),
            children: DIARY_DETAIL_CHILDREN,
            props: true,
        },
        {
            path: '/diaries/entry/:entryId(\\d+)/',
            component: () => import(/* webpackChunkName: "diary" */ './entry_detail_page/BlogEntryDetailPage'),
            children: getEntryDetailPageChildren(),
            props: true,
        },
    ]
});
